export const studioApiUrl = 
    (!process.env.NODE_ENV || process.env.NODE_ENV === 'development') ? 
        'http://localhost:3000/api/v1/' 
        : 
        window.location.origin  + "/api/v1/";

export const flowApiUrl = 
    (!process.env.NODE_ENV || process.env.NODE_ENV === 'development') ? 
        'http://localhost:4001'
        : 
        window.location.origin;
